import SampleCrudApi from '../data/api/sample-crud-api';

class SampleCrudRepository {
  constructor(state) {
    this.api = new SampleCrudApi(state);
  }

  getFiltered(page, rowsPerPage, orderBy, orderDirection) {
    return this.api.getFiltered(page, rowsPerPage, orderBy, orderDirection);
  }

  getById(id) {
    return this.api.getById(id);
  }

  create(data) {
    return this.api.create(data);
  }

  updateById(id, data) {
    return this.api.updateById(id, data);
  }

  deleteById(id) {
    return this.api.deleteById(id);
  }
}

export default SampleCrudRepository;
